import outreach from './outreach.json';
import followup from './followup.json';
import profile from './profile.json';

export default {
  outreach,
  followup,
  profile,
};
